export default "__VITE_ASSET__PWPdu08T__"